import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { dinnerQualities } from "../data/offer";
import { sounds } from "../utils/sounds";
import { UnlockGate } from "./UnlockGate";
import { OfferReveal } from "./OfferReveal";
export function OfferSection({
  goal,
  name
}: {
  goal: string;
  name: string;
}) {
  const [unlocked, setUnlocked] = useState(false);
  const handleUnlock = () => {
    sounds.unlock();
    setUnlocked(true);
  };
  return <section aria-labelledby="oferta-title" className="mt-14" data-id="element-135" data-mp="me1xrddm21jj">
      <h2 id="oferta-title" className="font-serif text-3xl font-semibold leading-tight text-cocoa sm:text-4xl" data-id="element-136" data-mp="rdwptk94gx66">
        Tu resultado muestra que tu cena podría estar haciendo trabajar de más a tu cuerpo mientras dormís.
      </h2>
      <p className="mt-4 text-lg leading-relaxed text-cocoa" data-id="element-137" data-mp="2t62v8sjggybx">
        La buena noticia: no necesitás otra dieta extrema. Necesitás una forma más inteligente de cenar después de los
        35.
      </p>

      <div className="mt-8 max-w-2xl" data-id="element-138" data-mp="12ojzklxzckqi">
        <p className="mb-4 font-serif text-xl leading-snug text-rose-700" data-id="element-139" data-mp="12plb0riwr98r">
          Según tus respuestas{name ? `, ${name}` : ""}, tu cuerpo podría necesitar una cena más simple, caliente y
          fácil de procesar por la noche.
        </p>
        <p className="text-base leading-relaxed text-cocoa" data-id="element-140" data-mp="own88k44yev6">
          Tu prioridad ahora es <strong className="font-semibold" data-id="element-141" data-mp="1lm4ep1ay04xx">{goal}</strong>, dejar de improvisar la cena y empezar
          con comidas nocturnas:
        </p>
        <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-142" data-mp="1gokznz6f7o4x">
          {dinnerQualities.map(q => <li key={q} className="flex items-start gap-2 text-base text-cocoa" data-id="element-143" data-mp="1ck4u5z0pyiq8">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-olive-600" aria-hidden="true" data-id="element-144" data-mp="17ljwa68xwb4y" />
              {q}
            </li>)}
        </ul>
      </div>

      <AnimatePresence mode="wait" data-id="element-145" data-mp="3sd3uvu96hj05">
        {unlocked ? <OfferReveal key="reveal" data-id="element-146" data-mp="3sb98ebi9dity" /> : <UnlockGate key="gate" name={name} onUnlock={handleUnlock} data-id="element-147" data-mp="3sf6un604uqi2" />}
      </AnimatePresence>
    </section>;
}